import { VisitDetailsField } from "@/pages/requests/components/visit-details-form/types";

export const NumberConfiguraions: VisitDetailsField[] = [
  VisitDetailsField.NumberOfPersonnel,
  VisitDetailsField.NumberOfVehicles,
  VisitDetailsField.NumberOfCameras,
  VisitDetailsField.NumberOfVessels,
];

export const WorkersOptions = [
  {
    Id: 0,
    Value: "Non-Personnel",
  },
  {
    Id: 1,
    Value: "Personnel",
  },
];
